<template>
  <a-data-table
    v-model="selected"
    :headers="headers"
    :items="documentlist"
    :single-select="singleSelect"
    item-key="name"
    show-select
    class="elevation-1 mt-2 max-height"
    hide-default-footer
    disable-sort
    dense
    fixed-header
  >
  </a-data-table>
</template>

<script>
export default {
  name: "EmailDocumentList",
  props: {
    documentlist: Array,
    value: {
      type: Array,
      required: () => [],
    },
  },
  data() {
    return {
      singleSelect: false,
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || []);
      },
    },
    headers() {
      return [
        {
          text: this.$t("agenda.lblDocumentName"),
          align: "start",
          sortable: false,
          value: "name",
          class: "header",
        },
      ];
    },
  },
};
</script>

<style scoped>
.max-height {
  max-height: 32vh;
  overflow: auto;
}

::v-deep .v-input--selection-controls__ripple {
  border-radius: unset !important;
  height: unset !important;
  width: unset !important;
}

.v-data-table /deep/ .sticky-header {
  position: sticky;
}

.v-data-table /deep/ .v-data-table__wrapper {
  overflow: unset;
}
</style>